import React, { useState, useEffect } from "react";
import {
  useObservable,
  useObserver,
  observer,
  useLocalStore,
  useAsObservableSource
} from "mobx-react-lite";
import {
  Pane,
  Select,
  SelectField,
  Table,
  Popover,
  Button,
  TextInputField,
  RadioGroup
} from "evergreen-ui";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { Query } from "react-apollo";
import Chance from "chance";
import _ from "lodash";
import gql from "graphql-tag";
import axios from "axios";
import { create } from "domain";
import downloadFile from "../services/downloadFile";
import Inviput from "@bit/krzysztofsikorski.components.inviput";
import { Pagination } from "../components/pagination/Pagination";
import { Autocomplete } from "../components/fields/Autocomplete";
import { typeQueries } from "../utils/typeQueries";
import { useThrottle } from "../utils/useThrottle";

const UPDATE_DOC = gql`
  mutation UpdateDoc($id: String!, $data: String!) {
    updateDoc(data: $data, id: $id)
  }
`;

const MASS_ACTION = gql`
  mutation MassAction(
    $type: String!
    $filters: [FilterInput]!
    $action: String
  ) {
    massAction(type: $type, filters: $filters, action: $action)
  }
`;

export default ({ types, doc, sectionId, role }) => {
  const [settings, setSettings] = useState(false);
  const [updateDoc] = useMutation(UPDATE_DOC);
  const activeDoc = useObservable(JSON.parse(doc.data));
  const section = activeDoc.sections.find(el => el._id === sectionId);

  // const activeSection = useObservable(_.cloneDeep(section))
  const newContent = () => {
    if (!section.content) section.content = [];
    section.content.push({});
  };
  const options = [
    { label: "nie wyświetlaj", value: "" },
    { label: "Z edycją", value: "write" },
    { label: "Tylko admin edytuje", value: "read" }
  ];
  return useObserver(() => (
    <Pane width="100%" paddingX="16px">
      {section.content &&
        section.content.map((view, index) => {
          const chosenType = types.find(el => el._id === view.type);
          const fields = chosenType ? JSON.parse(chosenType.data).fields : [];
          console.log(fields);
          return (
            <React.Fragment key={index}>
              {(section.settingsView !== "admin" || role === "admin") && (
                <Pane
                  float="right"
                  cursor="pointer"
                  onClick={() => setSettings(!settings)}
                >
                  <i
                  data-eva={settings ? "close-outline" : "settings-outline"}
                  />
                </Pane>
              )}
              {(!view.type || !view.view || settings) && (
                <>
                  <SelectField
                    label="Typ widoku"
                    value={view.type}
                    onChange={event => (view.type = event.target.value)}
                  >
                    <option value={false}>Wybierz typ...</option>
                    {types.map(type => (
                      <option key={type._id} value={type._id}>
                        {JSON.parse(type.data).name}
                      </option>
                    ))}
                  </SelectField>
                  {view.type && (
                    <SelectField
                      label="Sposób prezentacji"
                      value={view.view}
                      onChange={event => (view.view = event.target.value)}
                    >
                      <option value={false}>Wybierz wygląd...</option>
                      <option value="table">Tabela</option>
                    </SelectField>
                  )}
                  {view.type && (
                    <TextInputField
                      label="Szablon drukowania"
                      placeholder="Wpisz nazwę..."
                      value={view.printTemplate}
                      onChange={event =>
                        (view.printTemplate = event.target.value)
                      }
                    />
                  )}
                  {view.type && (
                    <>
                      {fields.map(field => (
                        <React.Fragment>
                          <RadioGroup
                            label={field.name}
                            value={view.fields ? view.fields[field.name] : ""}
                            options={options}
                            onChange={value => {
                              if (!view.fields) view.fields = {};
                              view.fields[field.name] = value;
                            }}
                          />
                          <input
                            value={
                              view.fieldsOrder
                                ? view.fieldsOrder[field.name]
                                : ""
                            }
                            onChange={e => {
                              if (!view.fieldsOrder) view.fieldsOrder = {};
                              view.fieldsOrder[field.name] = e.target.value;
                            }}
                          />
                        </React.Fragment>
                      ))}
                    </>
                  )}
                  {view.type && (
                    <>
                      Filtry
                      {(view.filters || []).map(filter => (
                        <Pane>
                          <TextInputField
                            label="Pole filtru"
                            placeholder="Wpisz pole..."
                            value={filter.field}
                            onChange={event =>
                              (filter.field = event.target.value)
                            }
                          />
                          <TextInputField
                            label="Pole wyświetlania"
                            placeholder="Wpisz pole..."
                            value={filter.display}
                            onChange={event =>
                              (filter.display = event.target.value)
                            }
                          />
                        </Pane>
                      ))}
                      <Pane
                        onClick={() => {
                          if (!view.filters) view.filters = [];
                          view.filters.push({
                            field: "",
                            display: ""
                          });
                        }}
                      >
                        Nowy
                      </Pane>
                    </>
                  )}

                  <hr />
                  <textarea
                    value={view.belowHTML}
                    onChange={e => {
                      view.belowHTML = e.target.value;
                    }}
                  />
                  <hr />
                  <Button
                    onClick={() =>
                      updateDoc({
                        variables: {
                          id: doc._id,
                          data: JSON.stringify(activeDoc)
                        },
                        refetchQueries: ["Docs"]
                      })
                    }
                  >
                    Zapisz
                  </Button>
                </>
              )}
              {!settings && view.view === "table" && (
                <DataStore
                  role={role}
                  view={view}
                  types={types}
                  type={types.find(el => el._id === view.type)}
                />
              )}
            </React.Fragment>
          );
        })}
      {!section.content || section.content.length === 0 ? (
        <Button iconBefore="plus" onClick={newContent}>
          Nowy dział
        </Button>
      ) : null}
    </Pane>
  ));
};

const Uneditable = ({ value }) => (
  <Pane>{_.isObject(value) ? value.value : value}</Pane>
);
const NumberAPI = ({ value }) => <Pane>{value.short}</Pane>;
const Text = ({ value, onChange, onBlur }) => (
  <Inviput size={14} value={value || ""} onChange={onChange} onBlur={onBlur} />
);
const Number = Text;
const Enum = ({ field, value, onChange, variants, onBlur }) => {
  const vars = field.subtype === "preset" ? presets[field.preset] : variants;
  const randomize = () => {
    const item = vars[Math.floor(Math.random() * vars.length)];
    onChange(item.key);
    onBlur();
  };
  if (!value) randomize();
  return (
    <>
      <Select
        padding="0"
        onChange={val => {
          onChange(val);
          onBlur();
        }}
        value={value}
      >
        <option value={false}>Wybierz...</option>
        {vars.map(el => (
          <option key={el.key} value={el.key}>
            {el.value}
          </option>
        ))}
      </Select>
      <i onClick={randomize} data-eva={"refresh-outline"}
></i>
    </>
  );
};

const Relation = ({ value, onChange, onBlur, types, field }) => {
  const type = types.find(el => el._id === field.connected) || field.connected;
  const multi = field.multi === "multi";
  // const [active, setActive] = useState(false)
  // const [searching, setSearching] = useState('')

  return (
    <Popover
      content={
        <Autocomplete
          type={type}
          onChoose={val => {
            onChange(val);
            onBlur();
          }}
          multi={multi}
          value={value}
        />
      }
    >
      <Button width="100%">
        {multi
          ? value.length
            ? value.map(el => el.value).join(", ")
            : "Wybierz..."
          : value && value.value
          ? value.value
          : "Wybierz..."}
      </Button>
    </Popover>
  );
};

const colors = [
  { key: "#ff0000", value: "czerwony" },
  { key: "#00b300", value: "zielony" },
  { key: "#0000b3", value: "niebieski" },
  { key: "#ffff00", value: "żółty" }
];

const icons = [
  { key: "cube", value: "Sześcian" },
  { key: "cube2", value: "Sześcian 2" },
  { key: "cylinder", value: "Cylinder" },
  { key: "circle", value: "Koło" },
  { key: "square", value: "Kwadrat" },
  { key: "triangle", value: "Trójkąt" },
  { key: "five", value: "Pięciokąt" },
  { key: "six", value: "Sześciokąt" }
];

const presets = {
  colors,
  icons
};

const omitTypeName = obj => {
  if (!_.isObject(obj)) return obj;
  const mappedValues = _.mapValues(obj, val => {
    if (!_.isObject(val)) return val;
    if (_.isArray(val)) return val.map(omitTypeName);
    return omitTypeName(val);
  });
  return _.omit(mappedValues, ["__typename"]);
};

const Row = observer(
  ({
    checked,
    setChecked,
    row,
    updateData,
    fieldNames,
    deleteData,
    typeName,
    fields,
    types,
    shownFields,
    role
  }) => {
    const observableRow = useAsObservableSource(row);
    const copiedRow = useLocalStore(() => {
      return _.cloneDeep(observableRow);
    });
    return (
      <Table.Row id={row._id}>
        <Table.Cell flexBasis={40} flexShrink={0} flexGrow={0}>
          <input
            type="checkbox"
            checked={checked.some(el => el === row._id)}
            onChange={() => {
              setChecked(_.xor(checked, [row._id]));
            }}
          />
        </Table.Cell>
        {fields.map(field => {
          const { name, type } = field;
          const baseProps = {
            field,
            value: copiedRow[name],
            onChange: e => (copiedRow[name] = e.target ? e.target.value : e),
            onBlur: () => {
              console.log(copiedRow);
              console.log(omitTypeName(copiedRow));
              updateData({
                variables: {
                  id: copiedRow._id,
                  data: omitTypeName(copiedRow)
                }
              });
            }
          };
          if (!shownFields[name]) return null;
          return (
            <Table.Cell key={name}>
              {role === "admin" || shownFields[name] === "write" ? (
                <>
                  {(type === "text" || type === "number") && (
                    <Text {...baseProps} />
                  )}
                  {type === "enum" && <Enum {...baseProps} />}
                  {type === "relation" && (
                    <Relation types={types} {...baseProps} />
                  )}
                  {type === "numberAPI" && (
                    <NumberAPI types={types} {...baseProps} />
                  )}
                </>
              ) : (
                <>
                  <Uneditable {...baseProps} />
                </>
              )}
            </Table.Cell>
          );
        })}
      </Table.Row>
    );
  }
);

const Tab = ({
  filters,
  fieldNames,
  fields,
  data,
  aggregations,
  stats,
  pagination: { page, setPage },
  typeName,
  createData,
  updateData,
  deleteData,
  types,
  view,
  role,
  toggleFilter,
  setFilter,
  params
}) => {
  const [massAction] = useMutation(MASS_ACTION);
  console.log(aggregations);

  const [checked, setChecked] = useState(
    params.get("checked") ? [params.get("checked")] : []
  );

  const fulltextFilter = filters
    ? filters.find(el => el.field === "__fulltext")
    : false;

  const [fulltext, setFulltext] = useThrottle(
    fulltextFilter ? fulltextFilter.value : "",
    1000,
    value => setFilter("__fulltext", value)
  );

  const print = async () => {
    const checkedData = data[typeName].filter(el => checked.includes(el._id));
    // console.log(checkedData)
    // const response = await axios.post('http://localhost:9001/print', {
    //     template: 'example',
    //     entries: checkedData
    // })
    const response = await axios({
      url: process.env.REACT_APP_PRINT_URL,
      method: "POST",
      data: {
        template: view.printTemplate,
        entries: checkedData
      },
      responseType: "blob"
    });
    setChecked([]);
    downloadFile(response, "printed.pdf");
  };
  const massDelete = async () => {
    massAction({
      variables: {
        action: "delete",
        type: typeName,
        filters: [
          {
            field: "_id",
            values: checked
          }
        ]
      },
      refetchQueries: ["Data" + typeName]
    });
    setChecked([]);
  };

  const shownFields = view.fields || {};
  const sortedFieldNames = fieldNames.sort((field1, field2) => {
    const field1Value = view.fieldsOrder ? view.fieldsOrder[field1] || 0 : 0;
    const field2Value = view.fieldsOrder ? view.fieldsOrder[field2] || 0 : 0;
    return field2Value - field1Value;
  });
  return (
    <Pane>
      <Pane float="left" width="160px">
        {aggregations.map(aggregation => (
          <Pane>
            {aggregation.field}
            <Pane>
              {aggregation.values.map(value => (
                <Pane
                  onClick={() => {
                    toggleFilter(aggregation.field, value.value);
                  }}
                >
                  <input
                    type="checkbox"
                    checked={
                      filters &&
                      filters.some(
                        el =>
                          el.field === aggregation.field &&
                          el.value === value.value
                      )
                        ? "checked"
                        : ""
                    }
                  />
                  {value.display} - {value.count}
                </Pane>
              ))}
            </Pane>
          </Pane>
        ))}
      </Pane>
      <Pane width="calc(100% - 160px)" float="right">
        <Pane
          marginBottom="8px"
          disabled={checked.length === 0}
          color={checked.length === 0 ? "rgba(0,0,0,0.2)" : "black"}
        >
          <Pane display="inline" marginRight="16px">
            Akcje masowe:
          </Pane>
          {view.printTemplate && (
            <Pane
              display="inline"
              onClick={print}
              cursor={checked.length === 0 ? "default" : "pointer"}
            >
              <i data-eva='printer-outline' />
              &nbsp; drukuj
            </Pane>
          )}
          {role === "admin" && (
            <Pane
              display="inline"
              onClick={massDelete}
              cursor={checked.length === 0 ? "default" : "pointer"}
            >
              <i data-eva='close-outline' />
              &nbsp; usuń
            </Pane>
          )}
        </Pane>
        <Pane>
          <input value={fulltext} onChange={setFulltext} />
        </Pane>
        <Table marginBottom="16px">
          <Table.Head>
            <Table.TextHeaderCell flexBasis={40} flexShrink={0} flexGrow={0}>
              <input
                type="checkbox"
                checked={checked.length === data[typeName].length}
                onChange={() => {
                  if (checked.length === data[typeName].length) setChecked([]);
                  else setChecked(data[typeName].map(el => el._id));
                }}
              />
            </Table.TextHeaderCell>
            {sortedFieldNames.map(
              name =>
                shownFields[name] && (
                  <Table.TextHeaderCell key={name}>{name}</Table.TextHeaderCell>
                )
            )}
            {/* <Table.TextHeaderCell>
                    </Table.TextHeaderCell> */}
          </Table.Head>
          <Table.Body>
            {data[typeName].map(row => (
              <Row
                role={role}
                shownFields={shownFields}
                checked={checked}
                setChecked={setChecked}
                fields={fields}
                types={types}
                key={row._id}
                row={row}
                updateData={updateData}
                fieldNames={sortedFieldNames}
                deleteData={deleteData}
                typeName={typeName}
              />
            ))}
          </Table.Body>
        </Table>
        <Pagination
          totalCount={stats.totalCount}
          page={page}
          setPage={setPage}
          perPage={30}
        />
        <Button
          onClick={() =>
            createData({
              variables: { data: {} },
              refetchQueries: ["Data" + typeName]
            })
          }
        >
          Nowy wiersz
        </Button>
        <div
          dangerouslySetInnerHTML={{
            __html: view.belowHTML
          }}
        />
      </Pane>
      <Pane></Pane>
    </Pane>
  );
};

const DataStore = ({ type, types, view, role }) => {
  const {
    typeName,
    fields,
    fieldNames,
    GET_DATA,
    CREATE_DATA,
    UPDATE_DATA,
    DELETE_DATA,
    GET_AGGREGATIONS,
    GET_STATS
  } = typeQueries(type);

  const params = new URLSearchParams(window.location.search);
  const [filters, setFilters] = useState(
    params.get("box._id")
      ? [
          {
            field: "box._id",
            value: params.get("box._id")
          }
        ]
      : false
  );

  const [page, setPage] = useState(1);

  const [createData] = useMutation(CREATE_DATA);
  const [updateData] = useMutation(UPDATE_DATA);
  const [deleteData] = useMutation(DELETE_DATA);

  const formattedFilters = filters
    ? filters.reduce((agg, filter) => {
        const filterIndex = agg.findIndex(el => el.field === filter.field);
        if (filterIndex > -1) {
          agg[filterIndex].values.push(filter.value);
        } else {
          agg.push({
            field: filter.field,
            values: [filter.value]
          });
        }
        return agg;
      }, [])
    : [];

  const { data, error, loading, refetch } = useQuery(GET_DATA, {
    fetchPolicy: "no-cache",
    variables: {
      filters: formattedFilters,
      limit: 30,
      offset: (page - 1) * 30
    }
  });

  const { data: aggregations, error: aggError, loading: aggLoading } = useQuery(
    GET_AGGREGATIONS,
    {
      variables: {
        fields: view.filters || []
      }
    }
  );

  const { data: stats, error: statsError, loading: statsLoading } = useQuery(
    GET_STATS
  );

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (filters !== false)
      refetch({
        filters: formattedFilters
      });
  }, [filters]); // Refetch query on changed filters

  const toggleFilter = (field, value) => {
    const compareFilter = el => el.field === field && el.value === value;
    const not = func => el => !func(el);
    const currentFilters = filters === false ? [] : filters;
    const hasFilter = currentFilters.some(compareFilter);
    const filteredFilters = currentFilters.filter(not(compareFilter));
    const addedFilter = filteredFilters.concat({
      field,
      value
    });
    const finalFilters = hasFilter ? filteredFilters : addedFilter;
    setFilters(finalFilters);
  };

  const setFilter = (field, value) => {
    const compareFilter = el => el.field === field;
    const not = func => el => !func(el);
    const currentFilters = filters === false ? [] : filters;
    const filteredFilters = currentFilters.filter(not(compareFilter));
    const addedFilter = filteredFilters.concat({
      field,
      value
    });
    setFilters(addedFilter);
  };

  if (loading || aggLoading || statsLoading) return <Pane>Ładownaie...</Pane>;
  if (error || aggError || statsError) return <Pane>Error.</Pane>;

  return (
    <Tab
      params={params}
      filters={filters}
      toggleFilter={toggleFilter}
      setFilter={setFilter}
      data={data}
      aggregations={aggregations[typeName + "Aggs"]}
      stats={stats[typeName + "Stats"]}
      pagination={{
        page,
        setPage
      }}
      role={role}
      type={type}
      types={types}
      view={view}
      fields={fields}
      fieldNames={fieldNames}
      typeName={typeName}
      createData={createData}
      updateData={updateData}
      deleteData={deleteData}
    />
  );
};
